import LoadsDashboard from "./LoadsDashboard";

export default LoadsDashboard;